import Drawer from "../../../../drawer/Drawer";
import ManageHowItWorks from "../ManageHowItWorks";

const ManagehowItWorksDrawer = ({ open, close = () => {}, getResponse = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update How It Works" : "Add How It Works"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyclassName="p-0 max-h-[calc(100%-42px)]">
      <ManageHowItWorks getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManagehowItWorksDrawer;
